<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12">
      <PageTitle title="Carrinho Abandonado" />
    </b-col>
   
    <b-col class="mt-4">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=Bwwa9n3kWIA&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=3', 
            title: 'Carrinho Abandonado' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a class="btn btn-success" href="https://api.construp.com.br/assets/Carrinho abandonado.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
    </b-col>
    <b-col cols="12" class="mt-4">
      <PeriodsFilters
      ref="periodsFilters"
      :setDatesAutomatic="false"
      :startDate.sync="fields.startDate"
      :endDate.sync="fields.endDate"
      @click.native="list()"
      />
    </b-col>

    <b-col cols="12" class="mt-3">
      <input
        type="text"
        v-model.trim="fields.clientName"
        class="form-control"
        placeholder="Nome do cliente"
      />
    </b-col>
    
    <b-col cols="" class="mt-3">
      <b-button variant="success" @click="list()">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
    </b-col>
    
    <b-col cols="12" class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">
        {{ pagination.total }} Oportunidades encontradas
      </h3>
      <b-button
        v-if="!generatingSpreadsheet"
        pill
        variant="success"
        @click="generateRelatory()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Baixar planilha
      </b-button>
      <b-spinner v-else variant="success" label="Spinning"></b-spinner>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        responsive
        hover
        show-empty
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template> 

        <template #cell(totalValue)="data">
          {{ formatNumber(data.item.totalValue) }}
        </template>

        <template #cell(details)="data">
          <b-col class="pr-0">
            <b-button
              variant="outline-dark"
              size="sm"
              title="Detalhes do pedido"
              class="mr-2 mb-2"
              @click="$refs.orderDetailsCart.toggleOpen({ orderId: data.item.id })"
            >
              <i class="fas fa-eye"></i>
            </b-button>
          </b-col>
        </template>

      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>

    <VideoManual ref="videoManual"/>
    <OrderDetailsCart ref="orderDetailsCart" />
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as XLSX from 'xlsx';

import { formatNumber } from '@/utils';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';

import ORDER_STATUS from 'Enums/Order/Status.js';

import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import SelectItems from 'Components/Inputs/SelectItems.vue';
import OrderDetailsCart from 'Components/Order/OrderDetailsCart.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'CartAbandonedAppList',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
    SelectItems,
    OrderDetailsCart,
    VideoManual
  },
  data() {
    return {
      ORDER_STATUS,
      generatingSpreadsheet: false,
      loading: false,
      showConfirmationPopover: false,
      currentOrderBeingEditedId: 0,
      isRelatory: false,
      dataRelatory: [],
      fields: {
        clientName: '',
        orderNumber: null,
        startDate: '',
        endDate: '',
        status: [],
        selectedOrders: {},
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'date',
            label: 'Data',
            sortable: true,
          },
          {
            key: 'clientName',
            label: 'Cliente',
            sortable: true,
          },
          {
            key: 'purchaseOrigin',
            label: 'Origem',
            sortable: true,
          },
         {
            key: 'totalValue',
            label: 'Valor total',
            sortable: true,
          },
          {
            key: 'details',
            label: 'Detalhes',
            sortable: false,
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.list();
    },
  },
  mounted() {
    this.list();
  },
  methods: {
    formatNumber,
    ...mapActions('shopkeeper', ['getAppOrders', 'updateOrderStatus']),
    
    list() {
      this.loading = true;

      const { clientName, purchaseOrigin, orderNumber, startDate, endDate, status } =
        this.fields;

      this.getAppOrders({
        currentPage: this.pagination.currentPage,
        userId: this.userTypeId(),
        clerkId: this.whatClerkPermission(),
        clientName,
        purchaseOrigin,
        orderNumber,
        startDate,
        endDate,
        status,
        abandonedCart: true,
        isRelatory: this.isRelatory,
      })
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};
          if (this.isRelatory) {
            this.isRelatory = false;
            this.dataRelatory = data || [];
          } else {
            this.pagination.itemsPerPage = perPage || 15;
            this.pagination.total = total || 0;
            this.$set(this.table, 'records', data || []);
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os pedidos',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async generateRelatory(){
      this.isRelatory = true;
      await this.list();
      this.generateSpreadsheet();
    },

    generateSpreadsheet() {

      if (!this.dataRelatory || !this.dataRelatory.length) return;

      this.generatingSpreadsheet = true;
      const clientsData = XLSX.utils.json_to_sheet(
        this.convertColumnsNames(this.dataRelatory)
      );

      const excelFile = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(excelFile, clientsData, 'Lista de clientes');

      const currentDate = new Date().toLocaleDateString('pt-BR');
      const fileName = `Lista de pedidos - ${this.dadosUsuario.informacoes.nome_fantasia} - ${currentDate}`;

      setTimeout(() => {
        this.generatingSpreadsheet = false;
      }, 1000);

      XLSX.writeFile(excelFile, `${fileName}.xlsx`);
    },
    /**
     * @param {Array} records
     * @returns {Array}
     */
    convertColumnsNames(records) {
      if (!records || !records.length) return [];

      const returnArray = [];

      records.forEach((record) => {
        const cell = {};

        Object.keys(record).forEach((key) => {
          const tableColumn = this.table.headers.find((x) => x.key === key);
          if(tableColumn) {

            if (key === 'totalValue') {
              cell[`${tableColumn.label}`] = formatNumber(record[key]);
            }
  
            cell[`${tableColumn.label}`] = record[key];
          }
        });

        returnArray.push(cell);
      });
      return returnArray;
    },
    handleOrderNumber() {
      if (!this.fields.orderNumber) return;

      this.$set(this.fields, 'orderNumber', Math.abs(this.fields.orderNumber));
    },
    getPaymentTypeText(type) {
      const texts = {
        credit_card: 'Cartão de crédito',
        pix: 'Pix',
        all: 'Boleto',
        wallet: 'Carteira'
      };

      return texts[type] || 'N/A';
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.CARRINHO_ABANDONADO);

        if(permission.type == TypePermission.BALCONISTA){
          return this.dadosUsuario.id;
        }
      }
      return '';
    },
  },
};
</script>
